"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadGenRecommendationsV2 = exports.buildRecommendationsFetchOptionsV2 = exports.buildRecommendationsBodyV2 = void 0;
const monda_1 = require("@simplisafe/monda");
const browser_monads_1 = require("browser-monads");
const leadGen_1 = require("../../../secrets/leadGen");
const windowScreenSize_1 = require("../../../utils/windowScreenSize");
const capture_1 = require("../../capture");
const lead_1 = require("../../lead");
const LEAD_SOURCE_TYPE_GSB = 'guided_system_builder';
/**
 * Creates the value for source to insert into leads table entry
 * @returns
 */
const getLeadSourceGSB = () => {
    return `Guidedsystembuilder_${(0, windowScreenSize_1.getDeviceType)() === 'Mobile' ? 'mobile' : 'desktop'}`;
};
/**
 * Builds request body for leads Guided System Builder recommendation
 * @param params
 * @returns
 */
const buildRecommendationsBodyV2 = (params) => {
    const utmParams = (0, capture_1.getUTMParams)();
    return {
        components: params.components,
        email: params.email,
        'lead_promo_offer': (0, monda_1.safeProp)('leadPromoOffer', params).orNull(),
        'lead_source_details': 'null',
        'lead_source_type': LEAD_SOURCE_TYPE_GSB,
        'lead_source_version': JSON.stringify(params.leadSourceVersion || {}),
        'lead_type': 'null',
        locale: process.env.LOCALE,
        source: getLeadSourceGSB(),
        // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
        'url_path': browser_monads_1.window.location.pathname || '',
        'utm_campaign': utmParams.utm_campaign || null,
        'utm_medium': utmParams.utm_medium || null,
        'utm_source': utmParams.utm_source || null,
    };
};
exports.buildRecommendationsBodyV2 = buildRecommendationsBodyV2;
/**
 * Builds request body for leads Guided System Builder recommendation, merges default request parameters
 * @param params
 * @returns
 */
const buildRecommendationsFetchOptionsV2 = (params) => ({
    ...lead_1.defaultParams,
    body: JSON.stringify((0, exports.buildRecommendationsBodyV2)(params)),
});
exports.buildRecommendationsFetchOptionsV2 = buildRecommendationsFetchOptionsV2;
/**
 * Makes a request to leads service quote-wizard/recommendations api
 * Updates ss_leads & ss_leads_metadata tables and returns attributeHash
 * @see https://api.qa.commerce.simplisafe.com/release/leads/v1/docs#tag/Recommendations/paths/~1quote-wizard~1recommendation/post
 * @param request
 * @returns
 */
const leadGenRecommendationsV2 = (request) => (0, lead_1.leadsAPIRequestFactory)(`${leadGen_1.quoteWizardUrl}/recommendation`, (0, exports.buildRecommendationsFetchOptionsV2)(request));
exports.leadGenRecommendationsV2 = leadGenRecommendationsV2;
//# sourceMappingURL=index.js.map